function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.7 16.88h.7c1.15 0 2.09-.94 2.09-2.09v-.7H12.7v2.79zm-4.19-2.09c0 1.15.94 2.09 2.09 2.09h.7v-2.79H8.51v.7zm0-2.79v.7h2.79V9.91h-.7c-1.15 0-2.09.94-2.09 2.09z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.03 6.82l-5.75-4.03c-1.57-1.1-3.97-1.04-5.48.13L3.79 6.83C2.78 7.61 2 9.21 2 10.47v6.9C2 19.92 4.07 22 6.61 22h10.77a4.62 4.62 0 004.61-4.62V10.6c.01-1.35-.86-3.01-1.96-3.78zm-3.15 7.97a3.5 3.5 0 01-3.49 3.49H10.6c-1.92 0-3.49-1.56-3.49-3.49V12a3.5 3.5 0 013.49-3.49h2.79c1.92 0 3.49 1.56 3.49 3.49v2.79z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4 9.91h-.7v2.79h2.79V12c0-1.15-.94-2.09-2.09-2.09z"
})));